module.exports = __webpack_public_path__ + "img/lecturer.adf5a8fa.png";